import axios from "axios";
import { getAuthToken, setAuthToken } from "./authToken";
import { getActiveWorkspaceKey } from "./activeWorkspace";

const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://str-monitoring-production.up.railway.app", // Default to Railway backend URL
});

axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }
  const workspaceKey = getActiveWorkspaceKey();
  if (token && workspaceKey) {
    config.headers.set("X-Workspace-Key", workspaceKey);
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && getAuthToken()) {
      setAuthToken(null);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
